import { Controller } from "@hotwired/stimulus";
import { handleHttpResponse } from "../../utils/http_utils";

export default class extends Controller {
  updated(e) {
    handleHttpResponse({
      payload: e.detail[0],
      onSuccess: (response) => {
        document.dispatchEvent(new CustomEvent("customer:updated", { detail: { customer: response } }));
      },
    });
  }
}
